import React from 'react'
import { Row, Col } from 'react-bootstrap'

const ChartOptionBoolean = ({ optionId, label, value, error, onChange, className, isEnabled }) => {
  return (
    <Row className={className}>
      <Col xs={6} className="d-flex align-items-center nowrap">{label}</Col>
      <Col xs={6} className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          id={optionId}
          className={[
            'text-control-toggle',
            value ? 'text-control-toggle-active' : '',
          ].join(' ')}
          onClick={() => isEnabled && onChange(!value)}
          disabled={!isEnabled}
          aria-pressed={!!value}
        >
          <span />
        </button>
      </Col>
      {error && (
        <div className="col-12">
          <small>
            <i>{error}</i>
          </small>
        </div>
      )}
    </Row>
  )
}

export default React.memo(ChartOptionBoolean)
